'use client';
import { DialogTitleStyled } from './dialog-title.styles';

const DialogTitle = DialogTitleStyled;

export default DialogTitle;
